import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const steps = [{
  id: 1,
  label: 'STEP 01',
  title: 'Build your target audience',
  description: 'Define your ideal local business audience using filters like industry, location, revenue, and employee count. Build hyper-targeted lists for your marketing campaigns.',
  image: 'https://cdn.magicpatterns.com/uploads/gV7JHHXgbCBdaBrQXT1vTQ/Search_Filter.gif',
  alt: 'Openmart audience builder interface for local business marketing campaigns'
}, {
  id: 2,
  label: 'STEP 02',
  title: 'Enrich with decision-maker contacts',
  description: 'Automatically find verified owner emails, direct phone numbers, and tech stack data for every business in your audience. Get the contacts you need for direct outreach.',
  image: 'https://cdn.magicpatterns.com/uploads/4E8XS6hq3erKBoQYVewHu3/Enrichment_Results.gif',
  alt: 'Openmart contact enrichment showing verified owner emails and phone numbers'
}, {
  id: 3,
  label: 'STEP 03',
  title: 'Launch personalized campaigns',
  description: 'Use built-in email sequences with personalization variables to reach local business owners at scale. Track opens, replies, and conversions — all from one platform.',
  image: 'https://cdn.magicpatterns.com/uploads/ghAUxHRqZwkGmrU4amsETG/outreach_email_template.png',
  alt: 'Openmart email campaign editor with personalization and tracking'
}];
export function MarketingProductTour() {
  return <section className="py-40 bg-white relative overflow-hidden" data-id="element-5086">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-5087">
        <div className="text-center max-w-3xl mx-auto mb-32" data-id="element-5088">
          <div className="text-sm font-bold text-blue-600 tracking-widest uppercase mb-4" data-id="element-5089">
            Product Tour
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight tracking-tight" data-id="element-5090">
            See the <span className="text-blue-600" data-id="element-5091">product in action</span>
          </h2>
          <p className="text-xl text-slate-500 leading-relaxed" data-id="element-5092">
            From audience building to personalized outreach in minutes.
          </p>
        </div>

        <div className="space-y-36 md:space-y-52" data-id="element-5093">
          {steps.map((step, index) => {
          const isEven = index % 2 !== 0;
          return <div key={step.id} className={`flex flex-col ${isEven ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-16 lg:gap-28 items-center`} data-id="element-5094">
                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.7,
              delay: 0,
              ease: [0.25, 0.1, 0.25, 1]
            }} className="w-full lg:w-5/12 space-y-8" data-id="element-5095">
                  <div className="text-sm font-bold text-slate-400 tracking-widest uppercase" data-id="element-5096">
                    {step.label}
                  </div>
                  <h3 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight leading-tight" data-id="element-5097">
                    {step.title}
                  </h3>
                  <p className="text-lg text-slate-500 leading-relaxed" data-id="element-5098">
                    {step.description}
                  </p>
                  <div className="pt-2" data-id="element-5099">
                    <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-blue-600 font-semibold hover:text-blue-700 transition-colors group" data-id="element-5100">
                      Try for free
                      <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-5101" />
                    </a>
                  </div>
                </motion.div>

                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.7,
              delay: 0.15,
              ease: [0.25, 0.1, 0.25, 1]
            }} className="w-full lg:w-7/12" data-id="element-5102">
                  <div className="w-full rounded-2xl overflow-hidden shadow-xl ring-1 ring-black/5" data-id="element-5103">
                    <img src={step.image} alt={step.alt} className="w-full h-auto block" loading="lazy" data-id="element-5104" />
                  </div>
                </motion.div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}